import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important: Enable sending cookies with requests
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  // Check for session token first (Google OAuth)
  const sessionToken = localStorage.getItem('session_token');
  if (sessionToken) {
    config.headers.Authorization = `Bearer ${sessionToken}`;
  } else {
    // Fallback to legacy JWT token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Categories API
export const categoriesAPI = {
  getAll: () => api.get('/categories'),
};

// Apps API
export const appsAPI = {
  getHomepage: () => api.get('/apps'),
  getById: (id) => api.get(`/apps/${id}`),
  getByWeek: (weekId) => api.get(`/apps/week/${weekId}`),
  getByCategory: (categoryId, sort = 'upvotes') => api.get(`/apps/category/${categoryId}?sort=${sort}`),
  search: (query) => api.get(`/apps/search?q=${encodeURIComponent(query)}`),
  submit: (data) => api.post('/apps', data),
  update: (id, data) => api.put(`/apps/${id}`, data),
  delete: (id) => api.delete(`/apps/${id}`),
  getMyApps: () => api.get('/my-apps'),
  uploadScreenshots: (appId, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    return api.post(`/apps/${appId}/screenshots`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteScreenshot: (screenshotId) => api.delete(`/screenshots/${screenshotId}`),
  uploadLogo: (appId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/apps/${appId}/logo/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  generateLogo: (appId) => api.post(`/apps/${appId}/logo/generate`),
  generateLogoPreview: (appName, tagline) => {
    const formData = new FormData();
    formData.append('app_name', appName);
    formData.append('tagline', tagline);
    return api.post('/logo/generate-preview', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  upvote: (appId) => api.post(`/apps/${appId}/upvote`),
  trackClick: (appId) => api.post(`/apps/${appId}/track-click`),
  trackShare: (appId) => api.post(`/apps/${appId}/track-share`),
};

// Admin API
export const adminAPI = {
  getReviewQueue: () => api.get('/admin/review-queue'),
  reviewApp: (appId, data) => api.put(`/admin/apps/${appId}/review`, data),
  getApprovedApps: () => api.get('/admin/approved-apps'),
  delistApp: (appId) => api.post(`/admin/apps/${appId}/delist`),
};

export default api;
